/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ContactNotificationSubject {
    Email_MissionActivationMail = 1,
    Email_HitNotificationRule = 2,
    Email_PublishIssues = 3,
    Email_FailedInboundMail = 4,
    Email_EditorRequest = 5,
    Email_ChatMessage = 6,
    Email_TaskAlert = 7,
    Push_AddedChatMessage = 101,
    Push_StartedMission = 102,
    Push_Info = 103,
    Push_TaskAlert = 104,
    Push_DeviceAction = 105,
    Push_AddedIssueEvent = 106,
    Push_EditorRequest = 107,
}
